<template>
	<q-page padding>
		<div class="q-display-1 q-mb-md text-secondary">
			<q-icon name="far fa-question-circle" class="q-mb-sm" /> {{ $t(title_faq) }}
		</div>

		<div class="row gutter-sm q-mb-lg">
			<div class="col-xs-12 col-sm-12">
				<q-input
					v-model="question"
					:float-label="$t('question')"
					:error="$v.question.$error"
					@input="$v.question.$touch"
				/>
			</div>

			<div class="col-xs-12 col-sm-12">
				<!-- <q-input
					type="textarea"
					v-model="faq_question_answer"
					:float-label="$t('question_answer')"
					:error="$v.faq_question_answer.$error"
					@input="$v.faq_question_answer.$touch"
				/> -->
				<q-editor
					v-model="faq_question_answer"
					ref="content"
					:toolbar="[
						['bold', 'italic', 'strike', 'underline'],
						['left', 'center', 'right', 'justify'],
						// ['link', 'upload'],
						[
							{
								label: null,
								icon: 'fas fa-font',
								fixedLabel: true,
								fixedIcon: true,
								list: 'no-icons',
								options: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'code'],
							},
							{
								// label: null,
								// icon: 'fas fa-text-height',
								// fixedLabel: true,
								// fixedIcon: true,
								// list: 'no-icons',
								// options: [
								// 	'size-1',
								// 	'size-2',
								// 	'size-3',
								// 	'size-4',
								// 	'size-5',
								// 	'size-6',
								// 	'size-7',
								// ],
							},
							'removeFormat',
						],
						// ['quote', 'unordered', 'ordered'],
						['custom_btn'],
					]"
					:definitions="{
						bold: { label: null, icon: 'fas fa-bold' },
						italic: { label: null, icon: 'fas fa-italic' },
						strike: { label: null, icon: 'fas fa-strikethrough' },
						underline: { label: null, icon: 'fas fa-underline' },
						left: { label: null, icon: 'fas fa-align-left' },
						center: { label: null, icon: 'fas fa-align-center' },
						right: { label: null, icon: 'fas fa-align-right' },
						justify: { label: null, icon: 'fas fa-align-justify' },
						link: { label: null, icon: 'fas fa-link' },
						// upload: {
						// 	tip: null,
						// 	icon: 'fas fa-file-image',
						// 	handler: insertImg,
						// },
						removeFormat: { label: null, icon: 'fas fa-eraser' },
						quote: { label: null, icon: 'fas fa-quote-right' },
						unordered: { label: null, icon: 'fas fa-list-ul' },
						ordered: { label: null, icon: 'fas fa-list-ol' },
					}"
				>
					<q-btn
						slot="custom_btn"
						dense
						flat
						color="black"
						icon="fas fa-code"
						label="HTML"
						@click="show_html = true"
					/>
				</q-editor>
			</div>

			<div class="col-xs-12 col-sm-12">
				<q-select
					v-model="faq_category"
					:options="faq_categories"
					:float-label="$t('category')"
					:error="$v.faq_category.$error"
					@input="$v.faq_category.$touch"
				/>
			</div>

			<div class="col-xs-12 col-sm-12" v-if="show_public_faq">
				<p class="caption">
					{{ $t('public_question') }}
					<q-icon name="far fa-question-circle" class="cursor-pointer">
						<q-tooltip anchor="top middle" self="bottom middle" :offset="[10, 10]">
							{{
								$t(
									'if_marked_as_yes_this_question_will_be_accessible_to_non_logged_in_users'
								)
							}}
						</q-tooltip>
					</q-icon>
				</p>
				<q-toggle
					v-model="is_public"
					color="primary"
					keep-color
					:label="is_public ? $t('yes') : $t('no')"
				/>
			</div>

			<div class="col-xs-12 col-sm-12">
				<p class="caption">{{ $t('status') }}</p>
				<q-btn-toggle v-model="status" :toggle-color="getColorStatus" :options="statuses" />
			</div>
		</div>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
				<q-btn
					color="tertiary"
					class="full-width"
					:label="$t('back')"
					icon="fas fa-chevron-left"
					@click="$router.push({ name: 'admin_faqs' })"
				/>
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
				<q-btn
					color="secondary"
					class="full-width"
					:label="$t('save')"
					icon="far fa-save"
					@click="saveData()"
				/>
			</div>
		</div>
		<q-modal
			v-model="show_html"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
			no-backdrop-dismiss
			no-esc-dismiss
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="show_html = false" icon="fas fa-times" />
					<q-toolbar-title>
						HTML
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div class="row">
						<div class="col-12">
							<q-input
								type="textarea"
								rows="10"
								float-label="HTML"
								v-model="faq_question_answer"
							/>
						</div>
					</div>

					<div class="row gutter-sm justify-end q-mt-lg">
						<div class="col-xs-12 col-sm-3">
							<q-btn
								color="tertiary"
								class="full-width"
								:label="$t('close')"
								icon="fas fa-ban"
								@click="show_html = false"
							/>
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>
	</q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { date } from 'quasar'

export default {
	i18nOptions: { namespaces: ['common', 'faq', 'admin'] },

	data() {
		return {
			id: '',
			question: '',
			faq_question_answer: '',
			faq_category: '',
			show_html: false,
			upload_url: process.env.API_URL + '/files/policy/',
			status: 1,
			is_public: false,
			statuses: [
				{ label: this.$t('published'), value: 1 },
				{ label: this.$t('unpublished'), value: 2 },
			],
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			faq_categories: 'registration_lists/faq_categories',
			clients: 'params/clients',
			show_public_faq: 'params/login_show_public_faq',
			id_user_client_selected: 'common/id_user_client_selected',
		}),

		getHeader() {
			return {
				headers: {
					'Content-Type': 'multipart/form-data',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		title_faq() {
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					return obj.title_faq == '' ? 'faq' : obj.title_faq
				}
			}
		},

		getColorStatus() {
			if (this.status == 1) return 'positive'
			else return 'negative'
		},
		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '80vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},
	},

	methods: {
		saveData() {
			this.$v.$touch()

			if (!this.$v.$error) {
				this.$q.loading.show()

				let fd = new FormData()
				fd.append('question', this.question)
				fd.append('status', this.status)
				fd.append('is_public', this.is_public)
				fd.append('faq_question_answer', this.faq_question_answer)
				fd.append('faq_category', this.faq_category)

				if (this.id != 0) {
					this.$axios
						.put(`/admin_faq/faq_questions/${this.id}/`, fd, this.getHeader)
						.then((response) => {
							this.$q.loading.hide()

							this.$q.notify({
								message: this.$t('faq_edit_success'),
								type: 'positive',
								icon: 'far fa-save',
							})

							this.$router.push({ name: 'admin_faqs' })
						})
						.catch((e) => {
							this.$q.loading.hide()
							console.log(e)
						})
				} else {
					this.$axios
						.post(`/admin_faq/faq_questions/`, fd, this.getHeader)
						.then((response) => {
							this.$q.loading.hide()

							this.$q.notify({
								message: this.$t('faq_add_success'),
								type: 'positive',
								icon: 'far fa-save',
							})

							this.$router.push({ name: 'admin_faqs' })
						})
						.catch((e) => {
							this.$q.loading.hide()
							console.log(e)
						})
				}
			} else {
				this.$q.notify({
					message: this.$t('make_sure_that_all_fields_are_filled_in'),
					type: 'negative',
					icon: 'fas fa-exclamation-triangle',
					position: 'top',
				})
			}
		},

		fetchData() {
			this.$q.loading.show()

			this.$axios
				.get(`/admin_faq/faq_questions/${this.id}/`, this.getHeader)
				.then((response) => {
					this.question = response.data.question
					this.faq_question_answer = response.data.faq_question_answer
					this.faq_category = response.data.faq_category
					this.status = response.data.status
					this.is_public = response.data.is_public

					this.$q.loading.hide()
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},
	},

	created() {
		this.id = this.$route.params.id
		if (this.id != 0) this.fetchData()
	},

	watch: {
		$route: function(refreshPage) {
			this.id = this.$route.params.id
			if (this.id != 0) this.fetchData()
		},
	},

	validations() {
		return {
			question: { required },
			faq_question_answer: { required },
			faq_category: { required },
		}
	},
}
</script>

<style></style>
